module.exports = __webpack_public_path__ + "static/main_photo-167ac005c0bc3f0c3fa1aa40fd7e9910.jpg";